import ApexChartsPackage from 'apexcharts';
import waitUntil from 'async-wait-until';

/* global KTApp */

export default class ProgressChart {
  static selectorString() {
    return '.ProgressChart';
  }

  async render(node, props) {
    await waitUntil(() => !!KTApp.getSettings().colors);

    const color = this.getColor();

    const options = {
      series: [Number(props.progress) * 100],
      chart: {
        height: 250,
        type: 'radialBar',
        offsetY: 0,
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: {
            margin: 0,
            size: `70%`,
          },
          dataLabels: {
            showOn: 'always',
            name: {
              show: true,
              fontSize: '13px',
              fontWeight: '700',
              offsetY: -5,
              color: KTApp.getSettings().colors.gray['gray-500'],
            },
            value: {
              formatter: val => Number(props.title),
              color: KTApp.getSettings().colors.gray['gray-700'],
              fontSize: '30px',
              fontWeight: '700',
              offsetY: -40,
              show: true,
            },
          },
          track: {
            background: KTApp.getSettings().colors.theme.light[color],
            strokeWidth: '100%',
          },
        },
      },
      colors: [KTApp.getSettings().colors.theme.base[color]],
      stroke: {
        lineCap: 'round',
      },
      labels: [props.subtitle],
    };

    const chart = new ApexChartsPackage(node.querySelector('.chart-container'), options);
    chart.render();
  }

  getColor() {
    const progress = Number(this.props.progress);

    if (progress < 0.2) {
      return 'danger';
    }
    if (progress < 0.5) {
      return 'warning';
    }
    if (progress < 0.75) {
      return 'primary';
    }

    return 'success';
  }
}
